// Funções puras da matriz de incompatibilidade, separadas dos componentes para
// poderem ser testadas sem montar árvore React nem store.

// A chave é sempre normalizada (menor id primeiro): o backend devolve os pares
// já ordenados, mas a grade consulta nos dois sentidos.
export const pairKey = (a, b) => (a < b ? `${a}:${b}` : `${b}:${a}`)

export const buildPairIndex = (incompatibilities = []) =>
  incompatibilities.reduce((acc, pair) => {
    acc[pairKey(pair.product_ids[0], pair.product_ids[1])] = pair
    return acc
  }, {})

export const findPair = (pairIndex, a, b) => pairIndex[pairKey(a, b)]

export const indexProducts = (products = []) =>
  products.reduce((acc, product, position) => {
    acc[product.id] = { ...product, position: position + 1 }
    return acc
  }, {})

// Estado visual de uma célula. Espelha o helper Ruby usado no PDF
// (app/helpers/incompatibility_grid_helper.rb), para tela e papel não divergirem.
//
// A diagonal é SEMPRE compatível: um produto não conflita consigo mesmo no uso real, e
// dar-lhe estado próprio custava duas entradas de legenda. Um produto que declara o
// próprio atributo (ácido forte que repele ácido forte) é cadastro legítimo: serve para
// separá-lo de OUTROS ácidos fortes, e é assim que aparece nas demais células.
export const cellState = (row, col, pairIndex) => {
  if (row.id === col.id) return 'ok'

  const pair = findPair(pairIndex, row.id, col.id)

  if (!pair) return 'ok'

  return pair.stale ? 'stale' : 'bad'
}

export const productsWithoutMatrix = (products = []) =>
  products.filter(product => !product.has_matrix)

// Nomes para os avisos. Numa área com dezenas de produtos sem matriz a lista inteira
// empurraria a matriz para fora da tela, então o excedente vira contagem.
export const namesSummary = (products = [], limit = 10) => {
  const names = products.map(product => product.name)

  if (names.length <= limit) return names.join(', ')

  return `${names.slice(0, limit).join(', ')} e mais ${names.length - limit}`
}

export const stalePairs = (incompatibilities = []) =>
  incompatibilities.filter(pair => pair.stale)



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/gridUtils.js